/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnTranscoreUser.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/pnn-transcore-user";

export class AutogenModelPnnTranscoreUser<RowType extends ModelRow> extends Endpoint<RowType, RowPnnTranscoreUserFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnTranscoreUser extends ModelRow<RowPnnTranscoreUserFields> {
	constructor(values?: Partial<RowPnnTranscoreUserFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnTranscoreUserFields {
	access_token: string;
	company_id: string;
	destination_radius: number;
	flash: string;
	highlight: string;
	login_token_1: string;
	login_token_2: string;
	max_alarm_matches: number;
	origin_radius: number;
	partial: string;
	pnn_service_id: string;
	refresh_token: string;
	token_expiration: Date;
	transcore_password: string;
	transcore_user_id: string;
	truckstop_user_email: string;
	user_id: string;
}

